import { createFileRoute } from "@tanstack/react-router";
import CertificateTypeManager from "@/features/inventory/CertificateTypeManager";
import { RequireCapability } from "@/components/require-capability";

export const Route = createFileRoute("/settings/inventory/certificate-types")({
  component: () => (
    <RequireCapability cap="inventory:manage">
      <SettingsCertTypesPage />
    </RequireCapability>
  ),
});

function SettingsCertTypesPage() {
  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-4">
      <div>
        <h1 className="text-lg font-semibold">Certificate Types</h1>
        <p className="text-sm text-muted-foreground">
          Manage certificate types for suppliers and products.
        </p>
      </div>
      <CertificateTypeManager onClose={() => {}} />
    </div>
  );
}
